import React from "react";
import { Link } from "react-router-dom";
import { resolveImageUrl } from "../services/api";
import { Clock, Camera } from "lucide-react";
import LiveScores from "./LiveScores";

const HeroSection = ({ featured, categories = [] }) => {
  if (!featured) return null;

  const featuredCategory = categories.find((c) => c.id === featured.category);

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Featured Article - Large */}
        <div className="lg:col-span-2">
          <Link
            to={`/article/${featured.id}`}
            className="group block relative rounded-2xl overflow-hidden bg-gray-900 aspect-[16/9]"
          >
            <img
              src={resolveImageUrl(featured.image)}
              alt={featured.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
              style={{ objectPosition: `${featured.image_focal_x ?? 50}% ${featured.image_focal_y ?? 50}%` }}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-6 sm:p-8">
              <span
                className="inline-block text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full text-white mb-3"
                style={{ backgroundColor: featuredCategory?.color || "#1B7A3D" }}
              >
                {featuredCategory?.name}
              </span>
              <h1 className="text-2xl sm:text-3xl lg:text-4xl font-black text-white leading-tight mb-3 group-hover:text-green-300 transition-colors duration-300">
                {featured.title}
              </h1>
              <p className="text-gray-300 text-sm sm:text-base line-clamp-2 mb-4 max-w-2xl">
                {featured.excerpt}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={featured.author?.avatar}
                  alt={featured.author?.name}
                  className="w-8 h-8 rounded-full border-2 border-white/30"
                />
                <span className="text-white text-sm font-medium">
                  {featured.author?.name}
                </span>
                <span className="text-gray-400 text-sm">·</span>
                <div className="flex items-center gap-1 text-gray-400 text-sm">
                  <Clock size={14} />
                  {featured.readTime}
                </div>
              </div>
              {featured.image_credit && (
                <div className="flex items-center gap-1 mt-2">
                  <Camera size={11} className="text-gray-400" />
                  <span className="text-[10px] text-gray-400">
                    Photo: {featured.image_credit}
                  </span>
                </div>
              )}
            </div>
          </Link>
        </div>

        {/* Live Scores Widget */}
        <LiveScores />
      </div>
    </section>
  );
};

export default HeroSection;
